import React from 'react'
import { Spin } from 'antd'

export default function LoadingComponent(props) {
  if (props.error) {
    // When the loader has errored
    return (
      <div className="center-spin">Error loading this section. Please try reloading the page.</div>
    )
  } else if (props.timedOut) {
    // When the loader has taken longer than the timeout
    return renderCenterSpinner()
  } else if (props.pastDelay) {
    // When the loader has taken longer than the delay
    return renderCenterSpinner()
  } else {
    // When the loader has just started
    //return null
    return renderCenterSpinner()
  }
}

function renderCenterSpinner() {
  return (
    <div className="spin-container">
      <div className="center-spin">
        <Spin size="large" />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js